<div style="display: flex; flex-direction: row;">
  <div *ngIf="configuration.isMultiSelection" class="file-selection-input">
    <i class="fa fa-2x checked fa-check-square-o" (click)="unSelectFile()"></i>
    <i class="fa fa-2x unchecked fa-square-o" (click)="selectFile()"></i>
  </div>
  <div style="flex:0 0 20px">
    <div class="rounded file-img small" [ngClass]="{'file-img-symbol': true}"
         [style.background-image]="'url(' + file.thumbnailUrl + ')'"></div>
  </div>
  <div style="flex:1 1 auto" class="file-name">{{file.name}}</div>
  <div style="flex:0 0 10em">{{file._orgData.lastModified | date: 'shortDate'}}</div>
  <div style="flex:0 0 auto" >
    <div class="btn-group btn-group-sm">
      <button *ngIf="!selectOnly" (click)="deleteFile($event, file)" class="btn btn-sm btn-primary btn-danger btn-icon">
        <i class="fa fa-trash"></i>
      </button>
      <button *ngIf="!selectOnly" (click)="download($event)" class="btn btn-sm btn-secondary btn-icon">
        <i class="fa fa-download"></i>
      </button>
    </div>
  </div>

</div>


<!-- Add message: [message]="getRemoveMessage(file)" -->
<!--button mwlConfirmationPopover [title]="removeTitle" [appendToBody]="true"
        [confirmText]="'Yes'" [cancelText]="'No'" placement="bottom" (confirm)="deleteFile($event, file)"
        class="btn btn-sm btn-danger btn-icon">
  <i class="fa fa-trash"></i>
</button-->
<!--button (click)="openPreview($event)" class="btn btn-sm btn-secondary btn-icon">
  <i class="fa fa-search"></i>
</button-->
